import { useHistory } from "react-router-dom";
import {
  MyReservationContentWrapper,
  MyReservationHeader,
  MyReservationWrapper,
} from "./styled";
import { useEffect, useState } from "react";
import {
  getUserReservationList,
  reservationCancel,
  UserReservationResponse,
} from "../../../api/reservation";
import MyReservationFilter from "./component/filter";
import MyReservationList from "./component/reservationList";
import ReservationStatusPopup from "../CompanyReservation/component/ReservationStatusPopup";
import { Reservation } from "../CompanyReservation/types";
import { cancelCompanyReservation } from "../../../api/reservation-company";
import { enqueueSnackbar } from "notistack";
import ReservationCancelPopup from "./component/isCancel";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";

const MyReservation = () => {
  const history = useHistory();
  const [list, setList] = useState<UserReservationResponse[]>([]);
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [currentOpen, setCurrentOpen] = useState<boolean>(false);
  const [currentList, setCurrentList] = useState<Reservation[]>([]);
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [cancelItem, setCancelItem] = useState<UserReservationResponse | null>(
    null
  );
  const inset = useRecoilValue(insetState);

  const getData = async () => {
    try {
      const res = await getUserReservationList(year, month);
      setList(res);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getData();
  }, [year, month]);

  const handleCancel = async () => {
    if (!cancelItem) return;
    if (cancelItem.isSpecial) {
      enqueueSnackbar("특별초대권으로 예약된 토너먼트는 취소할 수 없습니다. ", {
        variant: "error",
      });
      setIsCancel(false);
      return;
    }
    try {
      if (cancelItem.pubType === "RUNNER") {
        const startDate = new Date(cancelItem.tournament.startDate);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        const startDateOnly = new Date(startDate);
        startDateOnly.setHours(0, 0, 0, 0);

        const dDayRemaining = Math.ceil(
          (startDateOnly.getTime() - currentDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
        if (dDayRemaining <= 3) {
          enqueueSnackbar("대회 시작 3일 전에는 예약을 취소할 수 없습니다. ", {
            variant: "error",
          });
          setIsCancel(false);
          return;
        }
        await cancelCompanyReservation(cancelItem.id);
      } else {
        await reservationCancel(cancelItem.id);
      }
      enqueueSnackbar("해당 토너먼트 예약 취소되었습니다. ", {
        variant: "success",
      });
      setIsCancel(false);
      getData();
    } catch (e: any) {
      enqueueSnackbar(e.message, {
        variant: "error",
      });
      console.error(e);
      setIsCancel(false);
    }
  };

  return (
    <MyReservationWrapper isApp={inset}>
      {currentOpen && (
        <ReservationStatusPopup
          isOpen={currentOpen}
          onClose={() => setCurrentOpen(false)}
          reservations={currentList}
        />
      )}
      {isCancel && (
        <>
          <ReservationCancelPopup
            onClose={() => setIsCancel(false)}
            handleCancel={handleCancel}
          />
        </>
      )}
      <MyReservationHeader isApp={inset}>
        <div
          className="close"
          onClick={() => {
            history.goBack();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 19L5 12M5 12L12 5M5 12H19"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="title">예약 목록</div>
      </MyReservationHeader>
      <MyReservationContentWrapper>
        <div className="filter-wrapper">
          <MyReservationFilter
            filterList={[2025, 2026]}
            setValue={setYear}
            value={year}
            label="년"
          />
          <MyReservationFilter
            filterList={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
            setValue={setMonth}
            value={month}
            label="월"
          />
        </div>
        <MyReservationList
          list={list}
          setCurrentList={setCurrentList}
          setCurrentOpen={setCurrentOpen}
          getList={getData}
          setIsCancel={setIsCancel}
          setCancelItem={setCancelItem}
        />
      </MyReservationContentWrapper>
    </MyReservationWrapper>
  );
};

export default MyReservation;
